import { BooleanInput } from '@angular/cdk/coercion';
import { NgClass, NgFor, NgIf } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, forwardRef, Input, OnDestroy, OnInit } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { FakturniaNavigationService } from '@fakturnia/components/navigation/navigation.service';
import { FakturniaNavigationItem } from '@fakturnia/components/navigation/navigation.types';
import { FakturniaVerticalNavigationBasicItemComponent } from '@fakturnia/components/navigation/vertical/components/basic/basic.component';
import { FakturniaVerticalNavigationCollapsableItemComponent } from '@fakturnia/components/navigation/vertical/components/collapsable/collapsable.component';
import { FakturniaVerticalNavigationDividerItemComponent } from '@fakturnia/components/navigation/vertical/components/divider/divider.component';
import { FakturniaVerticalNavigationSpacerItemComponent } from '@fakturnia/components/navigation/vertical/components/spacer/spacer.component';
import { FakturniaVerticalNavigationComponent } from '@fakturnia/components/navigation/vertical/vertical.component';
import { Subject, takeUntil } from 'rxjs';

@Component({
    selector       : 'fakturnia-vertical-navigation-group-item',
    templateUrl    : './group.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone     : true,
    imports        : [NgClass, NgIf, MatIconModule, NgFor, FakturniaVerticalNavigationBasicItemComponent, FakturniaVerticalNavigationCollapsableItemComponent, FakturniaVerticalNavigationDividerItemComponent, forwardRef(() => FakturniaVerticalNavigationGroupItemComponent), FakturniaVerticalNavigationSpacerItemComponent],
})
export class FakturniaVerticalNavigationGroupItemComponent implements OnInit, OnDestroy
{
    /* eslint-disable @typescript-eslint/naming-convention */
    static ngAcceptInputType_autoCollapse: BooleanInput;
    /* eslint-enable @typescript-eslint/naming-convention */

    @Input() autoCollapse: boolean;
    @Input() item: FakturniaNavigationItem;
    @Input() name: string;

    private _fakturniaVerticalNavigationComponent: FakturniaVerticalNavigationComponent;
    private _unsubscribeAll: Subject<any> = new Subject<any>();

    /**
     * Constructor
     */
    constructor(
        private _changeDetectorRef: ChangeDetectorRef,
        private _fakturniaNavigationService: FakturniaNavigationService,
    )
    {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void
    {
        // Get the parent navigation component
        this._fakturniaVerticalNavigationComponent = this._fakturniaNavigationService.getComponent(this.name);

        // Subscribe to onRefreshed on the navigation component
        this._fakturniaVerticalNavigationComponent.onRefreshed.pipe(
            takeUntil(this._unsubscribeAll),
        ).subscribe(() =>
        {
            // Mark for check
            this._changeDetectorRef.markForCheck();
        });
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void
    {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Track by function for ngFor loops
     *
     * @param index
     * @param item
     */
    trackByFn(index: number, item: any): any
    {
        return item.id || index;
    }
}
